export default {
    productExtras: [],
    totalDataRow:0 
}
  